import { DemandWalkSingleContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const DemandWalkSinglePage = () => {
  return (
    <PageFrame>
      <DemandWalkSingleContainer />
    </PageFrame>
  );
};
